<template>
	<div class="contribute" v-if="showContribute">
		<p class="contribute_top"><span></span><strong>企业投稿</strong></p>
		<div class="contribute_con">
			<p class="m_b80">以打造企业交流平台、展示企业发展成果、推进企业质量工作为宗旨，积极向社会推介有实力、有信誉、有担当的优质企业。为把企业信息宣传作为服务会员企业的一项重要工作，中国质量协会将面向会员企业增设“会员动态”栏目，常态化刊登会员企业信息稿件，宣传会员企业先进的质量管理理念、特色做法、典型经验。</p>
			<div class="contribute_upload">
				<p class="deful upload_tit">投稿上传</p>
				<div class="upload_con">
					<p style="color: #CFD4D6;line-height: 20px;text-indent: 100px;">{{filename}}</p>
					<span>上传投稿文件</span>
					<div class="add">
						<label for="file" style="position: absolute;top: 0;left: 0;right: 0;bottom: 0;z-index: 10; "></label>
						<input type="file" id="file" class="file" @change="uploadFile($event)" multiple="multiple" accept='.doc'>
					</div>
					<span class="upload" @click="upload">提交</span>
				</div>
				<p class="note" style="color: red;">请使用doc文档格式上传，图片直接插入文档中，如若多个文件请扫描至一个文件里上传文档限定10MB以内。</p>
				<p class="deful" style="margin-bottom: 20px;">投稿要求</p>
				<p class="pro">
					1、征集会员企业在质量活动中的新闻素材、管理经验、工具方法等信息稿件。<br> 
					2、字数控制在800字以内，以WORD文档格式提交，文档标题命名格式“日期+企业名称+投稿”，例如：20190607中国XXX公司投稿.doc。<br> 
					3、要求保证宣传材料的真实性、准确性。<br>
					4、相关配图直接插入文档中（不超过三张）。
				</p>
			</div>

			<div class="contribute_his">
				<p class="his_tit"><strong class="deful">投稿记录</strong><span>通过审核的投稿，可在官网首页“会员动态”专栏查看</span></p>
				<ul>
					<li v-for="(item, index) in contributeDate" :key="index">
						<span class="list_name">{{item.file_name}}.doc </span>
						<span class="list_status" :class="status=='1'?'green':(status=='2'?'red':'')">{{item.contribute_status=='1'?'已通过审核':(item.contribute_status=='2'?'未通过审核':'已提交')}}</span>
					</li>					
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import Qs from 'qs'
	export default {
		data() {
			return {
				file: '',
				filename: '',
				status: '已通过审核',
				contributeDate:[],
			};
		},
		props: {
			showContribute: {
				type: Boolean
			}
		},
		created() {

		},
		updated(){
			
		},
		mounted() {
			this.getHis();
		},
		methods: {
			getHis(){
				if(sessionStorage.getItem('Token')) {
					var token = sessionStorage.getItem('Token');
				};			
				var data1={
					'access-token':token
				};
				this.$axios({
					method: 'post',
					url: 'contribute/record',
					data: Qs.stringify(data1)
				}).then(response => {
					console.log(response.data);
					if(response.data.state == 1) {
						this.contributeDate = response.data.info;
					}
				});
			},
			uploadFile(event) {
				console.log(event.target.files[0])
				const isLt2M = event.target.files[0].size / 1024 / 1024 < 10 // 上传头像图片大小不能超过 2MB
				if(!isLt2M) {
					this.$toast('图片选择失败，每张图片大小不能超过 10MB,请重新选择!');
				} else {
					this.file = event.target.files[0]; //获取input的图片file值
					this.filename = event.target.files[0].name;
					this.$toast('文件选择成功!');
				}
			},
			upload() {
				if(this.filename == "") {
					this.$toast('请选择要上传的文件！')
					return false
				};
				if(sessionStorage.getItem('Token')) {
					var token = sessionStorage.getItem('Token');
				}
				let fileFormData = new FormData();
				fileFormData.append('file', this.file, this.filename); //filename是键，file是值，就是要传的文件，test.zip是要传的文件名
				fileFormData.append('access-token',token);
				let requestConfig = {
					headers: {
						'Content-Type': 'multipart/form-data'
					},
				};
				this.$axios.post('contribute/index', fileFormData, requestConfig).then(response => {
					console.log(response.data);
					
					if(response.data.state==5){
						this.$toast(response.data.msg);
						this.getHis();
					}else{
						this.$toast(response.data.msg);
					}
					
				});
			}
		}
	}
</script>
<style scoped>
	.deful {
		font-size: 16px;
		color: #000;
		font-weight: bold;
	}
	
	.m_b80 {
		margin-bottom: 80px;
	}
	
	.m_b100 {
		margin-bottom: 100px;
	}
	
	.green {
		color: #16A085;
	}
	
	.red {
		color: #FF2851;
	}
	
	.contribute {
		width: 100%;
		height: auto;
		font-family: PingFangSC-Regular;
		font-size: 14px;
		color: #595959;
		text-align: left;
	}
	
	/*.contribute_top {
		color: #595959;
		font-size: 16px;
		line-height: 45px;
		font-weight: bold;
	}*/
	
	.contribute_top {
		padding-left: 18px;
		color: #005EB3;
		font-size: 18px;
		line-height: 45px;
		font-weight: bold;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}
	.contribute_top span{
		width:4px;
		height:16px;
		background:#4799E4;
		margin-right: 7px;
	}
	.contribute_con {
		width: 100%;
		text-align: left;
		height: auto;
		/*background: rgba(255, 255, 255, 1);
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04);*/
		padding: 28px 49px 45px 40px;
		box-sizing: border-box;
	}
	
	.contribute_upload,
	.contribute_his {
		border-top: 1px solid #CFD4D6;
	}
	
	.upload_tit,
	.his_tit {
		margin: -36px 0 36px;
	}
	
	.upload_con {
		line-height: 32px;
		width: 100%;
		height: 32px;
		margin-bottom: 30px;
	}
	
	.add {
		vertical-align: middle;
		display: inline-block;
		position: relative;
		cursor: pointer;
		font-size: 14px;
		font-family: PingFangSC-Regular;
		font-weight: 400;
		color: rgba(0, 0, 0, 0.65);
		line-height: 32px;
		width: 106px;
		height: 32px;
		background: rgba(255, 255, 255, 1) url(../../static/img/input.png) no-repeat;
		background-size: 100%;
		margin: 0 37px 0 15px;
	}
	.add:active{
		background: rgba(24, 144, 255, 1);
		color: #fff;
		border:none;
	}
	.file {
		position: absolute;
		left: -9999px;
	}
	
	.upload {
		cursor: pointer;
		text-align: center;
		display: inline-block;
		width: 53px;
		height: 31px;
		background: rgba(0, 118, 255, 1);
		border-radius: 3px;
		color: #fff;
	}
	.upload:active{
		background: blue;
	}
	.note {
		text-indent: 99px;
		color: #CFD4D6;
		margin-bottom: 17px;
	}
	
	.pro {
		line-height: 35px;
		margin-bottom: 65px;
	}
	
	.his_tit span {
		margin-left: 20px;
		font-size: 14px;
		color: #CFD4D6;
	}
	.contribute_his ul{
		height: 230px;
		overflow-y: scroll;
		width: 70%;
	}
	.contribute_his li {
		display: flex;
		align-items: center;
		width: 100%;
		padding-left:20px;
		box-sizing: border-box;
		height: 44px;
	}
	.list_name{
		float: left;
		width:85%;
		padding-right: 20px;
		box-sizing: border-box;
		color: #000;
	}
	.list_status{
		line-height: 42px;
		float: right;
	}
	.contribute_his li:nth-child(odd) {
		background: #D7D7D7;
		border: 1px solid #D7D7D7;
	}
	
	.contribute_his li:nth-child(even) {
		border: 1px solid #EBEBEB;
	}
</style>


// WEBPACK FOOTER //
// src/components/Contribute.vue